import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);

const STORAGE_KEY = "silea_cart_v1";

const computeLineTotal = (line) => {
  const extras = (line.customizations || []).reduce((s, c) => s + (c.extra_price || 0), 0);
  return (line.base_price + extras) * line.quantity;
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch {}
    setLoaded(true);
  }, []);

  useEffect(() => {
    if (!loaded) return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items, loaded]);

  const addItem = useCallback((line) => {
    const lineWithTotal = { ...line, line_total: computeLineTotal(line) };
    setItems((prev) => [...prev, { ...lineWithTotal, _key: Date.now() + Math.random() }]);
    setOpen(true);
  }, []);

  const removeItem = (key) => setItems((prev) => prev.filter((i) => i._key !== key));

  const updateQty = (key, qty) =>
    setItems((prev) =>
      prev.map((i) =>
        i._key === key ? { ...i, quantity: qty, line_total: computeLineTotal({ ...i, quantity: qty }) } : i
      )
    );

  const clear = () => setItems([]);

  const total = items.reduce((s, i) => s + i.line_total, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clear, total, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
};
